// extracted by mini-css-extract-plugin
export default {"button":"ButtonAddTransactions_button__EDI0a"};